import { apiClient } from './api-client';
import {
  addThemeQuestionInputSchema,
  addThemeQuestionResponseSchema,
  deactivateThemeQuestionsResponseSchema,
  reactivateThemeQuestionsResponseSchema,
  deleteThemeQuestionsResponseSchema,
  deleteThemeQuestionsInputSchema,
  deactivateThemeImportResponseSchema,
  importThemeQuestionsResponseSchema,
  type AddThemeQuestionInput,
} from './theme-question-curation.contract';

export async function addThemeQuestion(themeId: string, input: AddThemeQuestionInput) {
  const body = addThemeQuestionInputSchema.parse(input);
  const response = await apiClient.post(`/themes/admin/imports/${themeId}/questions`, body);
  return addThemeQuestionResponseSchema.parse(response.data);
}

export async function deactivateThemeQuestions(themeId: string, questionIds: string[]) {
  const response = await apiClient.post(
    `/themes/admin/imports/${themeId}/questions/deactivate`,
    { questionIds },
  );
  return deactivateThemeQuestionsResponseSchema.parse(response.data);
}

export async function reactivateThemeQuestions(themeId: string, questionIds: string[]) {
  const response = await apiClient.post(
    `/themes/admin/imports/${themeId}/questions/reactivate`,
    { questionIds },
  );
  return reactivateThemeQuestionsResponseSchema.parse(response.data);
}

export async function deleteThemeQuestions(themeId: string, questionIds: string[], password: string) {
  const body = deleteThemeQuestionsInputSchema.parse({ questionIds, password });
  const response = await apiClient.post(`/themes/admin/imports/${themeId}/questions/delete`, body);
  return deleteThemeQuestionsResponseSchema.parse(response.data);
}

export async function deactivateThemeImport(themeId: string) {
  const response = await apiClient.delete(`/themes/admin/imports/${themeId}`);
  return deactivateThemeImportResponseSchema.parse(response.data);
}

export async function importThemeQuestions(themeId: string, file: File, language: string) {
  const body = new FormData();
  body.append('excelFile', file);
  body.append('language', language);
  const response = await apiClient.post(`/themes/admin/imports/${themeId}/questions/import`, body);
  return importThemeQuestionsResponseSchema.parse(response.data);
}
